import { CircleTick } from "../images/svg/icons";
import "../../scss/bookkeeping-styling-component/card-feature.style.scss";

interface CardFeatureProps {
  text: string;
}

export const CardFeature: React.FC<CardFeatureProps> = ({ text }) => {
  return (
    <li className="feature">
      <img src={CircleTick} alt="Check Icon" />
      <span>{text}</span>
    </li>
  );
};
